// Uniform & Asset Management: the stages its address can open. No React in here.
//
// Requests are read from 1Office and nothing is decided in ChannelPlex.
import { UNIFORM_TABS, type UniformTabKey } from '../uniformDashboard';
import type { DashboardListInfo } from './types';

/** Each stage's slug in the address. */
export const UNIFORM_STAGE_SLUG: Record<UniformTabKey, string> = {
  ack_pending: 'ack-pending',
  approval_pending: 'approval-pending',
  submitted: 'submitted',
  in_process: 'in-process',
  completed: 'completed',
};

/** The stage a slug names, or null for no slug and for one this dashboard does not know. */
export function uniformStageFromSlug(slug: string | null | undefined): UniformTabKey | null {
  const wanted = (slug ?? '').trim().toLowerCase();
  return UNIFORM_TABS.find((t) => UNIFORM_STAGE_SLUG[t.id] === wanted)?.id ?? null;
}

const STAGE_LINE: Record<UniformTabKey, string> = {
  ack_pending: 'Waiting for the person to confirm their sizes.',
  approval_pending: 'Waiting for the request to be approved.',
  submitted: 'Approved, not yet sent or handed over.',
  in_process: 'With the courier.',
  completed: 'Delivered or handed over. Cancelled and rejected requests are listed here too.',
};

/** Every list on the dashboard that can be opened by address: the five stages, by the names on its strip. */
export const LISTS: DashboardListInfo[] = UNIFORM_TABS.map((t) => ({
  slug: UNIFORM_STAGE_SLUG[t.id],
  name: t.label,
  line: STAGE_LINE[t.id],
}));
